import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { faEye, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { convertCountsToFixedValue } from '../../../helpers/convertCountsToFixedValue';
import { ASSETS_BASE_URL } from '../../../lib/constants';
import { UserAvatar } from '../basic/UserAvatar';
import FollowButton from '../basic/FollowButton';
import { NewAuthorsType } from './NewAuthors.type';

type AuthorLayoutProps = {
  item: NewAuthorsType;
  children: React.ReactNode; // typing for children
  classname: string; // for different stylings
  followCount?: number;
};

export default function AuthorLayout({
  item,
  classname,
  followCount,
  children
}: AuthorLayoutProps) {
  return (
    <div className={classname}>
      <div>
        <UserAvatar className="w-16 h-16 self-center m-4" user={item.user} />
      </div>
      <div className="top-textblock-width flex flex-col gap-2 justify-evenly">
        <h3 className="text-white text-sm font-bold">
          {item.user.username}
        </h3>
        <div className="flex gap-6">
          <div className="flex flex-row w-4/12">
            <FontAwesomeIcon icon={faEye} className="self-center text-white" />
            <p className="text-white text-xs font-bold ml-1.5">
              {convertCountsToFixedValue(item.views_count)}
            </p>
          </div>
          <div className="flex justify-between">
            <FontAwesomeIcon icon={faUserFriends} className="self-center text-white" />
            <p className="text-white text-xs font-bold ml-1.5">
              {convertCountsToFixedValue(followCount)}
            </p>
          </div>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}
